// extracted by css-extract-rspack-plugin
export default {"root":"VHfRp","content":"DRYtZ"};